export const getFileExtensionFromFileName = (fileName: string) => {
  return fileName.split(".").pop();
};
